<template>
  <div id="live_attendee_faq" style="display: none;" class="faq">
    <LiveDelegateAttendeeFAQ v-if="$store.state.attendee.type == 'delegate'"/>
    <LiveSupplierAttendeeFAQ v-if="$store.state.attendee.type == 'supplier'"/>
  </div>
</template>

<script>
import LiveDelegateAttendeeFAQ from './LiveDelegateAttendeeFAQ.vue'
import LiveSupplierAttendeeFAQ from './LiveSupplierAttendeeFAQ.vue'

export default {
  name: 'LiveAttendeeFAQ',
  components: { LiveDelegateAttendeeFAQ, LiveSupplierAttendeeFAQ }
}
</script>
